import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listDistritos:[],
  // newRole:[],
};

export const mutations = {
  GET_DISTRITOS({ context }, distritos) {
    let distritos_array = [];
    Object.entries(distritos).forEach(([key, val]) => distritos_array.push(val));
    return (state.listDistritos = distritos_array);
  }
};

export const actions = {
  GET_DISTRITOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // commit("SET_LOADING", false);
          commit("GET_DISTRITOS", response.data.data.distritos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_DISTRITO({ commit }, distrito) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(distrito)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_DISTRITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_DISTRITO({ commit }, distrito) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(distrito)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("EDIT_DISTRITO", response.data.data.distritos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_DISTRITO({ commit }, distrito) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      console.log(distrito);
      commit("SET_LOADING", true);
      ApiService.delete(distrito)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("DELETE_DISTRITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {//leer datos
  getDistritos: state => state.listDistritos,
  // newRole: state => state.newRole,
};
